// removed by extract-text-webpack-plugin
module.exports = {"page-sidebar":"page-sidebar","page-sidebar-nav":"page-sidebar-nav","sidebar-icon":"sidebar-icon","sidebar-icon-dashboard":"sidebar-icon-dashboard","sidebar-icon-report":"sidebar-icon-report","sidebar-icon-data_manage":"sidebar-icon-data_manage","sidebar-icon-statistics":"sidebar-icon-statistics","sidebar-icon-recycle_bin":"sidebar-icon-recycle_bin","sidebar-title":"sidebar-title","active":"active"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common/Sidebar/Index.scss
// module id = 1376
// module chunks = 0